/* eslint-disable */
var $ = window.jQuery = require('jquery');

import Router from 'vue-router'
import Vue from 'vue'
import store from './store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [{
    path: '/',
    name: 'landingPage',
    component: () => import( /* webpackChunkName: "landingPage" */ './view/landing-page/index.vue'),
    beforeEnter: (to, from, next) => {
      document.title = 'Oddvega - Admin'
      next();
    }
  },
  {
    path: '/login/',
    name: 'login',
    component: () => import( /* webpackChunkName: "adminDashboard" */ './view/login/index.vue'),
    beforeEnter: (to, from, next) => {
      document.title = 'Oddvega - Admin Login'
      next();
    }

  },
  {
    path: '/admin/',
    component: () => import( /* webpackChunkName: "admin" */ './view/admin/index.vue'),
    beforeEnter: (to, from, next) => {
      next();
    },
    children: [{
      path: '/',
      redirect: {
        name: 'adminDashboard'
      }
    },
    {
      path: '/dashboard/old/',
      name: 'adminDashboard',
      component: () => import( /* webpackChunkName: "adminDashboard" */ './view/dashboard/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getDashboardDetails')
        store.dispatch('getUserListDetailsOfDashboard')
        document.title = 'Oddvega - Dashboard'
        next()
      }
    },
    {
      path: '/dashboard/',
      name: 'adminDashboardNew',
      component: () => import( /* webpackChunkName: "adminDashboardNew" */ './view/private/admin-dashboard/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getDashboardDetails')
        document.title = 'Oddvega - Dashboard'
        next()
      }
    },
    {
      path: '/courses/add/',
      name: 'courseAdd',
      component: () => import( /* webpackChunkName: "courseAdd" */ './view/create-new-course/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getCourseCategory')
        document.title = 'Oddvega - Create Course'
        next()
      }
    },
    {
      path: '/course/:id',
      name: 'coursesection',
      component: () => import( /* webpackChunkName: "coursesSection" */ './view/unique-feature/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('sectionbycourseId', {
          id: to.params.id
        })
        store.dispatch('getCourseCategory')
        document.title = 'Oddvega - Courses'
        next();
      }
    },
    {
      path: '/courses/',
      name: 'coursesList',
      component: () => import( /* webpackChunkName: "coursesList" */ './view/private/view-course/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getCategoryListActn')
        document.title = 'Oddvega - Courses'
        return next();
      },
      beforeRouteUpdate(to, from, next) {
        next()
      }
    },
    {
      path: '/courses/delete/',
      name: 'deletedCoursesList',
      component: () => import( /* webpackChunkName: "deletedCoursesList" */ './view/delete-courses/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getCategoryListActn')
        document.title = 'Oddvega - Delete Courses'
        return next();
      },
      beforeRouteUpdate(to, from, next) {
        next()
      }
    },
    {
      path: '/course/search/result/:searchkeyword/',
      name: 'view-search',
      component: () => import( /* webpackChunkName: "coursesSearch" */ './view/courseSearch/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getCategoryListActn')
        document.title = 'Oddvega - Courses'
        return next();
      },
      beforeRouteUpdate(to, from, next) {
        next()
      }
    },
    {
      path: '/usercourses/category/:id/',
      name: 'usercourses',
      component: () => import( /* webpackChunkName: "coursesBycategory" */ './view/coursesBycategory/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getCategoryListActn')
        document.title = 'Oddvega - Courses'
        next();
      }
    },
    {
      path: '/user/',
      name: 'user',
      component: () => import( /* webpackChunkName: "usersList" */ './view/private/users/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getUserListDetails')
        document.title = 'Oddvega - Users'
        next()
      }
    },
    {
      path: '/categories/',
      name: 'courseCategoriesList',
      component: () => import( /* webpackChunkName: "courseCategoriesList" */ './view/private/course-categories/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getCategoriesListAction')
        document.title = 'Oddvega - Category'
        next()
      }
    },
    {
      path: '/payment/history/',
      name: 'paymentHistory',
      component: () => import( /* webpackChunkName: "paymentHistory" */ './view/private/payment-history/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getPaymnetHistories')
        document.title = 'Oddvega - Payment History'
        next();
      }
    },
    {
      path: '/courses/:id/tab/edit/:tabId/',
      name: 'tab-details-edit',
      component: () => import( /* webpackChunkName: "tabDetailsEdit" */ './view/tab-details-edit/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('sectionbycourseId', {
          id: to.params.id
        })
        document.title = 'Oddvega - Edit course tab'
        next();
      }
    },
    {
      path: '/courses/:courseId/tab/create/',
      name: 'tab-details-create',
      component: () => import( /* webpackChunkName: "tabDetailsAdd" */ './view/tab-details-create/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Add course tab'
        next();
      }
    },
    {
      path: '/course/:courseId/author/create/',
      name: 'authors',
      component: () => import( /* webpackChunkName: "authorDetails" */ './components/author-details-create/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Author'
        next();
      }
    },
    {
      path: '/course/:courseId/author/:authorId/edit/',
      name: 'authorsEdit',
      component: () => import( /* webpackChunkName: "authorUpdate" */ './components/author-details-edit/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Author Update'
        next();
      }
    },
    {
      path: '/course/:courseId/coursetype/',
      name: 'coursetype',
      component: () => import( /* webpackChunkName: "courseType" */ './components/coursetype/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - CourseType'
        next();
      }
    },
    {
      path: '/course/:courseId/coursetype/:courseTypeId/',
      name: 'updateCourseType',
      component: () => import( /* webpackChunkName: "updateCourseType" */ './components/update-coursetype/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - CourseType Update'
        next();
      }
    },
    {
      path: '/course/:courseId/producer/create/',
      name: 'producer',
      component: () => import( /* webpackChunkName: "courseProducerCreate" */ './components/create-course-producer/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Producer'
        next();
      }
    },
    {
      path: '/course/:courseId/producer/:producerId/edit/',
      name: 'producerUpdate',
      component: () => import( /* webpackChunkName: "courseProducerUpdate" */ './components/update-course-producer/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Producer Update'
        next();
      }
    },
    {
      path: '/courses/category/:categoryId/',
      name: 'courses-category',
      component: () => import( /* webpackChunkName: "categoryCourses" */ './view/category-courses/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getCourseCategoryId', {
          categoryId: to.params.categoryId
        })
        document.title = 'Oddvega - Courses'
        next();
      }
    },
    {
      path: '/user/:userId/',
      name: 'user-detail',
      component: () => import( /* webpackChunkName: "userDetail" */ './view/user-detail/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getUserListDetailsById', { id: to.params.userId })
        store.dispatch('getUserPointsObtained', { id: to.params.userId })
        store.dispatch('getUserQuizHistoryByIdFun', { id: to.params.userId })
        document.title = 'Oddvega - User Details'
        next();
      }
    },
    {
      path: '/subscription/plan/',
      name: 'subscription-plan',
      component: () => import( /* webpackChunkName: "subscriptionPlan" */ './view/subscription-plan/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getSubscriptionPlanList').then((res) => { }).catch((err) => { })
        document.title = 'Oddvega - Subscription Plan'
        next();
      }
    },
    {
      path: '/rlist-users/',
      name: 'rlistUsers',
      component: () => import( /* webpackChunkName: "rlistUsers" */ './view/rlist-users/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getRlistUserList')
          .then((res) => { })
          .catch((err) => { })
        document.title = 'Oddvega - RList Users'
        next();
      }
    },
    {
      path: '/email/',
      name: 'email',
      component: () => import( /* webpackChunkName: "Email" */ './view/user-email-template/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getUserListDetails')
        document.title = 'Oddvega - Email'
        next();
      }
    },
    {
      path: '/email&sms/compose/',
      name: 'emailCompose',
      component: () => import( /* webpackChunkName: "emailCompose" */ './view/global-message-user/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getUserListDetails')
        document.title = 'Oddvega - Email'
        next();
      }
    },
    {
      path: '/courses/:id/tab/',
      name: 'courseInfoById',
      component: () => import( /* webpackChunkName: "courseInfoById" */ './view/unique-feature/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('sectionbycourseId', {
          id: to.params.id,
          tab_name: 'details'
        })
        store.dispatch('getCourseCategory')
        document.title = 'Oddvega - Course Tab'
        next()
      }
    },
    {
      path: '/courses/:id/material/',
      name: 'CourseMaterialList',
      component: () => import( /* webpackChunkName: "CourseMaterialList" */ './view/unique-feature/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('sectionbycourseId', {
          id: to.params.id,
          tab_name: 'material'
        })
        store.dispatch('getCourseCategory')
        document.title = 'Oddvega - Course Material'
        next()
      }
    },
    {
      path: '/courses/:id/quiz/',
      name: 'QuizList',
      component: () => import( /* webpackChunkName: "QuizList" */ './view/unique-feature/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('sectionbycourseId', {
          id: to.params.id
        })
        store.dispatch('getCourseCategory')
        document.title = 'Oddvega - Quiz'
        next()
      }
    },
    {
      path: '/courses/:courseId/quiz/trash/',
      name: 'TrashQuizList',
      component: () => import( /* webpackChunkName: "TrashQuizList" */ './components/trash-quiz/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Quiz Trash'
        next()
      }
    },
    {
      path: '/courses/:courseId/quiz/create/',
      name: 'addquiz',
      component: () => import( /* webpackChunkName: "addQuiz" */ './components/add-quiz/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('sectionbycourseId', {
          id: to.params.courseId
        })
        document.title = 'Oddvega - Add New Quiz'
        next()
      }
    },
    {
      path: '/courses/:courseId/quiz/edit/:quizId/',
      name: 'quizDetailsEdit',
      component: () => import( /* webpackChunkName: "QuizDetailsEdit" */ './components/edit-quiz/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Edit Quiz Details'
        next();
      }
    },
    {
      path: '/courses/:courseId/quiz/:quizId/question-answer/list',
      name: 'QuizQueAns',
      component: () => import( /* webpackChunkName: "QuizQueAns" */ './components/quiz-question-answer/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getQuizDetailsByIdFun', {
          id: to.params.quizId
        })
        document.title = 'Oddvega - Quiz Question Answer'
        next();
      }
    },
    {
      path: '/courses/:courseId/quiz/:quizId/question-answer/create',
      name: 'CreateQuizQueAns',
      component: () => import( /* webpackChunkName: "CreateQuizQueAns" */ './components/quiz-question-answer-create/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getQuizDetailsByIdFun', {
          id: to.params.quizId
        })
        document.title = 'Oddvega - Quiz Create Question Answer'
        next();
      }
    },
    {
      path: '/courses/:courseId/quiz/:quizId/quizzes/history',
      name: 'quizzesHistory',
      component: () => import( /* webpackChunkName: "quizzesHistory" */ './components/quiz-history/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getQuizDetailsByIdFun', {
          id: to.params.quizId
        })
        store.dispatch('getQuizzesHistory', {
          id: to.params.courseId
        })
        document.title = 'Oddvega - Quiz History'
        next();
      }
    },
    {
      path: '/courses/:courseId/quiz/:quizId/question-answer/:QueAnsId/edit',
      name: 'editQuizQueAns',
      component: () => import( /* webpackChunkName: "editQuizQueAns" */ './components/quiz-question-answer-edit/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getQuizDetailsByIdFun', {
          id: to.params.quizId
        })
        document.title = 'Oddvega - Quiz Edit Question Answer'
        next();
      }
    },
    {
      path: '/course/public/quizzes/category/',
      name: 'pubQuizzesCat',
      component: () => import( /* webpackChunkName: "pubQuizzesCategory" */ './view/private/public-quiz-category/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getCategoriesListAction');
        document.title = 'Oddvega - Public Quiz Category'
        next();
      }
    },
    {
      path: '/course/public/quizzes/category/:quiz_catId/list/',
      name: 'pubQuizzesList',
      component: () => import( /* webpackChunkName: "pubQuizzesList" */ './view/public-quizzes-list/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Public Quiz List'
        next();
      }
    },
    {
      path: '/course/public/quizzes/:quiz_catId/add/',
      name: 'pubAddQuiz',
      component: () => import( /* webpackChunkName: "pubAddQuiz" */ './view/public-add-quiz/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getCourseCategory')
        document.title = 'Oddvega - Public Quiz Add'
        next();
      }
    },
    {
      path: '/course/public/quizzes/:quiz_catId/edit/:quizId/',
      name: 'pubEditQuiz',
      component: () => import( /* webpackChunkName: "pubEditQuiz" */ './view/public-edit-quiz/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getCourseCategory')
        document.title = 'Oddvega - Public Quiz Edit'
        next();
      }
    },
    {
      path: '/course/public/quizzes/:quiz_catId/question-answer/create/:quizId/',
      name: 'pubCreateQuizQueAns',
      component: () => import( /* webpackChunkName: "pubCreateQuizQueAns" */ './view/public-quiz-question-answer-create/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getQuizDetailsByIdFun', {
          id: to.params.quizId
        })
        document.title = 'Oddvega - Public Quiz Create Question Answer'
        next();
      }
    },
    {
      path: '/course/public/quizzes/:quiz_catId/question-answer/:quizId/edit/:QueAnsId/',
      name: 'pubEditQuizQueAns',
      component: () => import( /* webpackChunkName: "pubEditQuizQueAns" */ './view/public-quiz-question-answer-edit/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getQuizDetailsByIdFun', {
          id: to.params.quizId
        })
        document.title = 'Oddvega - Public Quiz Edit Question Answer'
        next();
      }
    },
    {
      path: '/course/public/quizzes/:quiz_catId/question-answer/:quizId/list/',
      name: 'pubQuizQueAns',
      component: () => import( /* webpackChunkName: "pubQuizQueAns" */ './view/public-quiz-question-answer/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getQuizDetailsByIdFun', {
          id: to.params.quizId
        })
        document.title = 'Oddvega - Public Quiz List Question Answer'
        next();
      }
    },
    {
      path: '/course/public/quizzes/:quiz_catId/history/:quizId/',
      name: 'pubQuizzesHistory',
      component: () => import( /* webpackChunkName: "pubQuizzesHistory" */ './view/public-quiz-history/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getQuizDetailsByIdFun', {
          id: to.params.quizId
        })
        store.dispatch('getQuizzesAllHistory')
        document.title = 'Oddvega - Public Quiz History'
        next();
      }
    },
    // Contest Quiz Active Add Routing
    {
      path: '/course/contest/quizzes/add/',
      name: 'contestQuizAnimation',
      component: () => import( /* webpackChunkName: "contestQuizAnimation" */ './view/contest-quizzes/quiz-animation/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Add Contest Quiz'
        next();
      }
    },
    // Contest Quiz Active Edit Routing
    {
      path: '/course/contest/quizzes/edit/:id',
      name: 'editContestQuizAnimation',
      component: () => import( /* webpackChunkName: "editContestQuizAnimation" */ './view/interview/unit-list/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Edit Contest Quiz'
        next();
      }
    },
    // Interview Quiz Route
    {
      path: '/interview/quiz/unit/list/',
      name: 'interviewUnitList',
      component: () => import( /* webpackChunkName: "interviewUnitList" */ './view/interview/unit-list/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Interview Unit'
        next();
      }
    },
    {
      path: '/interview/quiz/unit/info/edit/:quizId',
      name: 'interviewUnitInfoEdit',
      component: () => import( /* webpackChunkName: "interviewUnitInfoEdit" */ './view/interview/unit-contest-info-edit/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Interview Unit'
        next();
      }
    },
    {
      path: '/interview/quiz/unit/add/',
      name: 'interviewUnitAdd',
      component: () => import( /* webpackChunkName: "interviewUnitAdd" */ './view/interview/unit-info-add/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Interview Unit'
        next();
      }
    },
    {
      path: '/interview/quiz/unit/edit/:quizId/',
      name: 'interviewUnitEdit',
      component: () => import( /* webpackChunkName: "interviewUnitEdit" */ './view/interview/unit-info-edit/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Interview Unit'
        next();
      }
    },
    {
      path: '/interview/quiz/question-answer/add/:quizId/',
      name: 'interviewQuizzesAddQAns',
      component: () => import( /* webpackChunkName: "interviewQuizzesAddQAns" */ './view/interview/interview-quizzes-q-ans-add/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getIvQuizUniInfoByIdAction', {
          id: to.params.quizId
        })
        document.title = 'Oddvega - Interview Quiz'
        next();
      }
    },
    {
      path: '/interview/quiz/question-answer/edit/:quizId/:QueAnsId/',
      name: 'interviewQuizzesEditQAns',
      component: () => import( /* webpackChunkName: "interviewQuizzesEditQAns" */ './view/interview/interview-quizzes-q-ans-edit/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getIvQuizUniInfoByIdAction', {
          id: to.params.quizId
        })
        document.title = 'Oddvega - Interview Quiz'
        next();
      }
    },
    {
      path: '/interview/quiz/question-answer/list/:quizId/',
      name: 'interviewQuizzesQAnsList',
      component: () => import( /* webpackChunkName: "interviewQuizzesQAnsList" */ './view/interview/interview-quizzes-q-ans-list/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getIvQuizUniInfoByIdAction', {
          id: to.params.quizId
        })
        document.title = 'Oddvega - Interview Quiz'
        next();
      }
    },
    {
      path: '/interview/quiz/',
      name: 'interviewQuizzesList',
      component: () => import( /* webpackChunkName: "interviewQuizzesList" */ './view/interview/interview-quiz-list/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Interview Quiz List'
        next();
      }
    },
    {
      path: '/interview/quiz/add/',
      name: 'interviewAddQuiz',
      component: () => import( /* webpackChunkName: "interviewAddQuiz" */ './view/interview/add-interview-quiz/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getInterviewQuizListAction')
        document.title = 'Oddvega - Interview Add Quiz'
        next();
      }
    },
    {
      path: '/interview/quiz/edit/:quizId/',
      name: 'interviewEditQuiz',
      component: () => import( /* webpackChunkName: "interviewEditQuiz" */ './view/interview/edit-interview-quiz/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getInterviewQuizListAction')
        document.title = 'Oddvega - Interview Edit Quiz'
        next();
      }
    },
    {
      path: '/interview/quiz/history/:quizId/',
      name: 'interviewQuizzesHistory',
      component: () => import( /* webpackChunkName: "interviewQuizzesHistory" */ './view/interview/interview-quizzes-history/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Interview Quiz History'
        next();
      }
    },
    // Interview Quiz Route

    // Contest Quiz Routing
    {
      path: '/course/contest/quizzes/category/',
      name: 'contestQuizzesCat',
      component: () => import( /* webpackChunkName: "contestQuizzesCategory" */ './view/contest-quizzes/public-quiz-category/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getCategoryListActn')
          .then((res) => {
            store.dispatch('getQuizAnimationList')
          })
        document.title = 'Oddvega - Contest Quiz Category'
        next();
      }
    },
    {
      path: '/course/contest/quizzes/category/:quiz_catId/list/',
      name: 'contestQuizzesList',
      component: () => import( /* webpackChunkName: "contestQuizzesList" */ './view/contest-quizzes/public-quizzes-list/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Contest Quiz List'
        next();
      }
    },
    {
      path: '/course/contest/quizzes/:quiz_catId/add/',
      name: 'contestAddQuiz',
      component: () => import( /* webpackChunkName: "contestAddQuiz" */ './view/contest-quizzes/public-add-quiz/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getCourseCategory')
        document.title = 'Oddvega - Contest Quiz Add'
        next();
      }
    },
    {
      path: '/course/contest/quizzes/:quiz_catId/edit/:quizId/',
      name: 'contestEditQuiz',
      component: () => import( /* webpackChunkName: "contestEditQuiz" */ './view/contest-quizzes/public-edit-quiz/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getCourseCategory')
        store.dispatch('getSectionListForQuizFun', {
          id: to.params.quizId
        })
        document.title = 'Oddvega - Contest Quiz Edit'
        next();
      }
    },
    {
      path: '/course/contest/quizzes/:quiz_catId/question-answer/create/:quizId/',
      name: 'contestCreateQuizQueAns',
      component: () => import( /* webpackChunkName: "contestCreateQuizQueAns" */ './view/contest-quizzes/public-quiz-question-answer-create/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getQuizDetailsByIdFun', {
          id: to.params.quizId
        })
        document.title = 'Oddvega - Contest Quiz Create Question Answer'
        next();
      }
    },
    {
      path: '/course/contest/quizzes/:quiz_catId/question-answer/:quizId/edit/:QueAnsId/',
      name: 'contestEditQuizQueAns',
      component: () => import( /* webpackChunkName: "contestEditQuizQueAns" */ './view/contest-quizzes/public-quiz-question-answer-edit/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getQuizDetailsByIdFun', {
          id: to.params.quizId
        })
        document.title = 'Oddvega - Contest Quiz Edit Question Answer'
        next();
      }
    },
    {
      path: '/course/contest/quizzes/:quiz_catId/question-answer/:quizId/list/',
      name: 'contestQuizQueAns',
      component: () => import( /* webpackChunkName: "contestQuizQueAns" */ './view/contest-quizzes/public-quiz-question-answer/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getQuizDetailsByIdFun', {
          id: to.params.quizId
        }).then((res) => {
          document.title = 'Quiz - ' + res.data.data.name;
        })
          .catch((err) => {
            document.title = 'Quiz';
          })
        next();
      }
    },
    {
      path: '/course/contest/quizzes/:quiz_catId/history/:quizId/',
      name: 'contestQuizzesHistory',
      component: () => import( /* webpackChunkName: "contestQuizzesHistory" */ './view/contest-quizzes/public-quiz-history/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getQuizDetailsByIdFun', {
          id: to.params.quizId
        })
        store.dispatch('getQuizzesAllHistory', {
          id: to.params.quizId
        })
        document.title = 'Oddvega - Contest Quiz History'
        next();
      }
    },
    {
      path: '/course/contest/quizzes/:quiz_catId/feedback/:quizId/',
      name: 'contestQuizzesFeedback',
      component: () => import( /* webpackChunkName: "contestQuizzesFeedback" */ './view/contest-quizzes/contest-quiz-feedback/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getQuizDetailsByIdFun', {
          id: to.params.quizId
        })
        store.dispatch('getFeedbackOfContestFun', {
          id: to.params.quizId
        })
        document.title = 'Oddvega - Quiz Feedback'
        next();
      }
    },
    {
      path: '/course/contest/quizzes/:quiz_catId/reward/:quizId/create/',
      name: 'contestQuizzesRewardCreate',
      component: () => import( /* webpackChunkName: "contestQuizzesRewardCreate" */ './view/quizRewards/create-quiz-reward/index.vue'),
      beforeEnter: (to, from, next) => {
        // store.dispatch('getCourseCategory')
        document.title = 'Oddvega - Quiz Reward'
        next();
      }
    },
    {
      path: '/course/contest/quizzes/:quiz_catId/reward/:quizId/update/:quiz_rewardId/',
      name: 'contestQuizzesRewardUpdate',
      component: () => import( /* webpackChunkName: "contestQuizzesRewardUpdate" */ './view/quizRewards/update-quiz-reward/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getQuizRewardPointsDetailsByIdFun', {
          id: to.params.quiz_rewardId
        })
        document.title = 'Oddvega - Quiz Reward'
        next();
      }
    },
    {
      path: '/course/contest/quizzes/:quiz_catId/section/:quizId/create/',
      name: 'contestQuizzesSectionCreate',
      component: () => import( /* webpackChunkName: "contestQuizzesSectionCreate" */ './view/contest-quiz-section/contest-quiz-section-create/index.vue'),
      beforeEnter: (to, from, next) => {
        // store.dispatch('getCourseCategory')
        document.title = 'Oddvega - Quiz Section'
        next();
      }
    },
    {
      path: '/course/contest/quizzes/:quiz_catId/section/:quizId/update/:quiz_sectionId/',
      name: 'contestQuizzesSectionUpdate',
      component: () => import( /* webpackChunkName: "contestQuizzesSectionUpdate" */ './view/contest-quiz-section/contest-quiz-section-update/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getSectionDetailsByIdForQuizFun', {
          id: to.params.quiz_sectionId
        })
        store.dispatch('getSectionConfigForQuizFun', {
          id: to.params.quiz_sectionId
        })
        document.title = 'Oddvega - Quiz Section'
        next();
      }
    },
    {
      path: '/course/public/quizzes/images/list/',
      name: 'pubQuizzesImagesList',
      component: () => import( /* webpackChunkName: "pubQuizzesImagesList" */ './components/img-list-for-quiz/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getImgforQuizFun')
        document.title = 'Oddvega - Public Quiz Images List'
        next();
      }
    },
    {
      path: '/course/contest/quizzes/:quiz_catId/section/:quizId/config/:quiz_sectionId/create/',
      name: 'contestQuizzesSectionConfig',
      component: () => import( /* webpackChunkName: "contestQuizzesSectionConfig" */ './view/contest-quiz-section/contest-quiz-section-config/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Quiz Section Config'
        next();
      }
    },
    {
      path: '/course/contest/quizzes/:quizId/section/:quiz_sectionId/config/:sectionConfigId/update/',
      name: 'contestUpdateQuizzesSectionConfig',
      component: () => import( /* webpackChunkName: "contestUpdateQuizzesSectionConfig" */ './view/contest-quiz-section/contest-quiz-section-config-update/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getSectionConfigForQuizByIdFun', {
          id: to.params.sectionConfigId
        })
        document.title = 'Oddvega - Quiz Section Config'
        next();
      }
    },
    {
      path: '/author/user/list/',
      name: 'authorUserList',
      component: () => import( /* webpackChunkName: "authorUserList" */ './view/author-user-list/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getCourseAuthorListFun', {
        })
        document.title = 'Oddvega - Author User List'
        next();
      }
    },
    {
      path: '/author/user/list/create/',
      name: 'authorUserCreateList',
      component: () => import( /* webpackChunkName: "authorUserCreateList" */ './view/author-user-create/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getUserListDetails')
          .then((res) => { })
          .catch((err) => { })
        document.title = 'Oddvega - Author User List Create'
        next();
      }
    },
    {
      path: '/author/user/details/:authorId/',
      name: 'authorUserDetails',
      component: () => import( /* webpackChunkName: "authorUserDetails" */ './view/author-user-details/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getAuthorDetailsByIDFun', {
          id: to.params.authorId
        })
        document.title = 'Oddvega - Author Details'
        next();
      }
    },
    {
      path: '/author/user/details/:authorId/assign/new/course',
      name: 'authorAssignCourse',
      component: () => import( /* webpackChunkName: "authorAssignCourse" */ './view/author-assign-course/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getAuthorDetailsByIDFun', {
          id: to.params.authorId
        })
        store.dispatch('getcourselist')
        document.title = 'Oddvega - Author Assign New Course'
        next();
      }
    },
    {
      path: '/quizzes/all/',
      name: 'adminAllQuizzes',
      component: () => import( /* webpackChunkName: "adminAllQuizzes" */ './view/private/admin-quizzes-list/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Admin All Quizzes'
        next();
      }
    },
    {
      path: '/members/',
      name: 'Allmembers',
      component: () => import( /* webpackChunkName: "Allmembers" */ './view/private/member-list/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Admin All Members'
        next();
      }
    },
    {
      path: '/workspace/',
      name: 'workspace',
      component: () => import( /* webpackChunkName: "workspace" */ './view/private/workspace/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Admin Workspace'
        next();
      }
    },
    {
      path: '/workspace/support/',
      name: 'supportWorkspace',
      component: () => import( /* webpackChunkName: "supportWorkspace" */ './view/private/support-workspace/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Admin Support Workspace'
        next();
      }
    },
    {
      path: '/workspace/team/',
      name: 'teamWorkspace',
      component: () => import( /* webpackChunkName: "teamWorkspace" */ './view/private/team-workspace/index.vue'),
      beforeEnter: (to, from, next) => {
        document.title = 'Oddvega - Admin Team Workspace'
        next();
      }
    },
    ]
  },
  ]
})

const openRoutes = ['landingPage', 'login']
// Routes use for without login
router.beforeEach((to, from, next) => {
  if (openRoutes.includes(to.name)) {
    next();
  } else if (store.getters.isAuthenticated && localStorage.getItem('token') != '' && localStorage.getItem('token') != null) {
    next()
  } else {
    next('/')
  }
})

/** Show loader when moving routes */
router.beforeResolve((to, from, next) => {
  if (to.name) {
    if (openRoutes.includes(to.name)) {
      $('.app-loader.global').show();
    }
    next();
  }
})
/** Hide preloader after each routes */
router.afterEach((to, from) => {
  if (openRoutes.includes(to.name)) {
    $('.app-loader.global').hide();
  }
})
export default router;
